import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { NumericInput } from "@/components/ui/numeric-input";
import { DYNAMIC_INQUIRY_FIELDS } from "@/constants/data";

export const isDynamicStepValid = (propertyType, dynamicFields) => {
  const fields = DYNAMIC_INQUIRY_FIELDS[propertyType] || [];
  return fields.every((field) => Boolean((dynamicFields[field.name] || "").toString().trim()));
};

const DynamicSelectField = ({ field, value, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {field.options.map((opt) => (
      <button
        key={opt}
        type="button"
        data-testid={`inquiry-dynamic-${field.name}-${opt}`}
        onClick={() => onChange(field.name, opt)}
        className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
          value === opt
            ? "border-[color:var(--brand-gold)] bg-[color:hsl(var(--secondary))]"
            : "border-[color:var(--line)] text-[color:hsl(var(--muted-foreground))] hover:bg-[color:hsl(var(--secondary))]"
        }`}
      >
        {opt}
      </button>
    ))}
  </div>
);

/**
 * Step 3: dynamic sub-questions based on the selected property type (all required),
 * plus an optional free-text note.
 */
const DynamicFieldsStep = ({ propertyType, dynamicFields, message, onDynamicFieldChange, onMessageChange }) => {
  const fields = DYNAMIC_INQUIRY_FIELDS[propertyType] || [];

  return (
    <div className="flex flex-col gap-4">
      {fields.map((field) => {
        const filled = Boolean((dynamicFields[field.name] || "").toString().trim());
        return (
          <div key={field.name} className="flex flex-col gap-1.5">
            <Label>
              {field.label} <span className="text-[color:var(--brand-gold-2)]">*</span>
            </Label>
            {field.type === "select" ? (
              <DynamicSelectField field={field} value={dynamicFields[field.name]} onChange={onDynamicFieldChange} />
            ) : field.type === "number" ? (
              <NumericInput
                thousands={Boolean(field.thousands)}
                data-testid={`inquiry-dynamic-${field.name}`}
                value={dynamicFields[field.name] || ""}
                onChange={(v) => onDynamicFieldChange(field.name, v)}
                placeholder={field.placeholder}
              />
            ) : (
              <Input
                data-testid={`inquiry-dynamic-${field.name}`}
                value={dynamicFields[field.name] || ""}
                onChange={(e) => onDynamicFieldChange(field.name, e.target.value)}
                placeholder={field.placeholder}
              />
            )}
            {!filled && (
              <p className="text-xs text-[color:hsl(var(--muted-foreground))]" data-testid={`inquiry-dynamic-${field.name}-hint`}>
                Bu alanın doldurulması zorunludur.
              </p>
            )}
          </div>
        );
      })}
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="inquiry-message">Notunuz (opsiyonel)</Label>
        <Textarea
          id="inquiry-message"
          data-testid="inquiry-message-input"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          placeholder="Eklemek istediğiniz detaylar..."
          rows={3}
        />
      </div>
    </div>
  );
};

export default DynamicFieldsStep;
